import React from "react";
import { motion, Variants } from "framer-motion";

type Direction = "up" | "down" | "left" | "right" | "none";

interface RevealProps {
  children: React.ReactNode;
  direction?: Direction;
  delay?: number;
  duration?: number;
  className?: string;
  as?: "div" | "span";
  once?: boolean;
  distance?: number;
}

const offsets: Record<Direction, { x?: number; y?: number }> = {
  up: { y: 28 },
  down: { y: -28 },
  left: { x: 28 },
  right: { x: -28 },
  none: {},
};

export function Reveal({
  children,
  direction = "up",
  delay = 0,
  duration = 0.7,
  className,
  once = true,
  distance,
}: RevealProps) {
  const offset = offsets[direction];
  const scaled =
    distance !== undefined
      ? {
          x: offset.x !== undefined ? Math.sign(offset.x) * distance : undefined,
          y: offset.y !== undefined ? Math.sign(offset.y) * distance : undefined,
        }
      : offset;

  const variants: Variants = {
    hidden: { opacity: 0, ...scaled },
    visible: {
      opacity: 1,
      x: 0,
      y: 0,
      transition: { duration, delay, ease: [0.16, 1, 0.3, 1] },
    },
  };

  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="visible"
      viewport={{ once, margin: "-80px" }}
      variants={variants}
    >
      {children}
    </motion.div>
  );
}
